import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material';

import { selectThemeCoreDesignSystem } from 'store/global/selectors';

const CDS = memo(({ children }) => {
  const themeCoreDesignSystem = useSelector(selectThemeCoreDesignSystem);

  return <ThemeProvider theme={themeCoreDesignSystem}>{children}</ThemeProvider>;
});

const AppThemeProvider = CDS;
AppThemeProvider.CDS = CDS;

export default AppThemeProvider;
